import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
// @ts-expect-error ts-migrate(7016) FIXME
import SkeletonText from 'customer-data-reference-ui-components/name/SkeletonText';
import { formatMonthDayYearAtTimeString, formatTimeAgo } from '../../../utils/dateTimeFormatUtils';
import { Flex } from 'foundations-components/components/Flex';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import I18n from 'I18n';
import { Small } from 'foundations-components/transitional/components/Small';

// We need to hard code the height so it matches that of the actual header otherwise the initial
// scroll to comment time is off by 18px per comment before where it's suppose to scroll to
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getDateDisplay = (createdAt, compact) => {
  if (compact) {
    return /*#__PURE__*/_jsx(FormattedDateTime, {
      value: I18n.moment(createdAt),
      format: "lll",
      type: "userTz"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "objectCommentsThread.comments.timeSpanAgo",
    options: {
      timeSpan: formatTimeAgo(createdAt)
    }
  });
};
export const CommentHeader = props => {
  const {
    status,
    name,
    anchor,
    comment,
    compact = false,
    hideDate = false
  } = props;
  if (status === 'loading') {
    return /*#__PURE__*/_jsx(Box, {
      blockSize: "42px",
      children: /*#__PURE__*/_jsx(SkeletonText, {
        width: 80,
        "data-test-id": "comment-header-skeleton"
      })
    });
  }
  const headerContent = /*#__PURE__*/_jsxs("strong", {
    children: [anchor, anchor && ' - ', name]
  });
  const dateDisplay = getDateDisplay(comment.createdAt, compact);
  const isEdited = comment.createdAt !== comment.updatedAt;
  if (compact) {
    return /*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      alignItems: "baseline",
      children: [/*#__PURE__*/_jsx(Box, {
        "data-test-id": "compact-comment-header",
        children: headerContent
      }), !hideDate && /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [dateDisplay, isEdited && /*#__PURE__*/_jsx(Text, {
          as: "span",
          display: "inline-block",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "objectCommentsThread.comments.edited"
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      "data-test-id": "comment-header",
      children: headerContent
    }), !hideDate && /*#__PURE__*/_jsx(Box, {
      "data-test-id": "comment-date-container",
      children: /*#__PURE__*/_jsxs(Text, {
        as: "small",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: formatMonthDayYearAtTimeString(comment.createdAt),
          "data-test-id": "comment-date-tooltip",
          children: dateDisplay
        }), isEdited && /*#__PURE__*/_jsx(Tooltip, {
          title: formatMonthDayYearAtTimeString(comment.updatedAt),
          children: /*#__PURE__*/_jsx(Text, {
            as: "span",
            display: "inline-block",
            marginInlineStart: "100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "objectCommentsThread.comments.edited"
            })
          })
        })]
      })
    })]
  });
};